jQuery(document).ready(function ($) {
    $('.social-sharing .share').on('click', function (e) {
        if($(this).hasClass('button-mail')) {
            return;
        }

        e.preventDefault();

        var url = $(this).attr('href');
        var title = $(this).attr('title');

        window.open(url, title, 'width=600,height=622');
    });
});